import React from 'react'
import PaymentInfoContainer from 'src/containers/MyPage/PaymentInfo'

const PaymentInfoPage: React.FC = () => {
  return <PaymentInfoContainer />
}

export const PATH = '/my-page/payment-info' as const
export default PaymentInfoPage
